var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFollowersDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.229,
    height: 18,
    viewBox: "0 0 17.229 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157156",
    "data-name": "Rectangle 157156",
    width: 17.23,
    height: 18,
    fill: "#678bff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_38250",
    "data-name": "Mask Group 38250",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "followers_2_",
    "data-name": "followers (2)",
    transform: "translate(0.015)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75097",
    "data-name": "Group 75097",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75096",
    "data-name": "Group 75096"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73728",
    "data-name": "Path 73728",
    d: "M7.878,16.563H2.033a.657.657,0,0,1-.543-.289.721.721,0,0,1-.1-.629,5.206,5.206,0,0,1,4.924-3.663,4.877,4.877,0,0,1,2.889.946.654.654,0,0,0,.935-.174.722.722,0,0,0-.167-.977,6.3,6.3,0,0,0-1.34-.747A3.634,3.634,0,0,0,9.747,8.674a4.894,4.894,0,0,1,6.412-.547.654.654,0,0,0,.935-.174.722.722,0,0,0-.167-.977,6.3,6.3,0,0,0-1.34-.747,3.644,3.644,0,0,0,1.123-2.648A3.509,3.509,0,0,0,13.286,0,3.509,3.509,0,0,0,9.859,3.579a3.644,3.644,0,0,0,1.115,2.64q-.141.057-.279.12a6.315,6.315,0,0,0-1.183.71A3.437,3.437,0,0,0,6.332,4.8,3.509,3.509,0,0,0,2.906,8.383a3.645,3.645,0,0,0,1.109,2.635,6.624,6.624,0,0,0-3.9,4.2A2.162,2.162,0,0,0,.4,17.1a1.969,1.969,0,0,0,1.629.865H7.878a.7.7,0,0,0,0-1.4ZM13.286,1.4a2.133,2.133,0,0,1,2.083,2.176,2.085,2.085,0,1,1-4.165,0A2.133,2.133,0,0,1,13.286,1.4Zm-6.953,4.8A2.133,2.133,0,0,1,8.415,8.382a2.133,2.133,0,0,1-2.083,2.176A2.133,2.133,0,0,1,4.25,8.383,2.133,2.133,0,0,1,6.332,6.207Z",
    transform: "translate(-0.015)",
    fill: "#678bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73729",
    "data-name": "Path 73729",
    d: "M17.33,11.464a.653.653,0,0,0-.937.162l-3.311,4.832a.374.374,0,0,1-.264.137.368.368,0,0,1-.288-.107l-2.144-2.15a.652.652,0,0,0-.95.02.724.724,0,0,0,.019.992L11.6,17.5a1.693,1.693,0,0,0,1.192.5q.057,0,.114,0a1.71,1.71,0,0,0,1.232-.67l.023-.031,3.325-4.852A.722.722,0,0,0,17.33,11.464Z",
    transform: "translate(-0.411)",
    fill: "#678bff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowersDark);
export default __webpack_public_path__ + "static/media/FollowersDark.e4509273e5ac6d16dccb50e460ff47b5.svg";
export { ForwardRef as ReactComponent };